export default "__VITE_ASSET__62c05fce__"